const whitelist = new Set(['persist:layerOpacity']);

export function clearPortalLocalStorage() {
  Object.keys(localStorage).forEach(key => {
    if (!whitelist.has(key)) {
      localStorage.removeItem(key);
    }
  });
}
